export enum dayTimeEnum {
  MORNING = "morning",
  AFTERNOON = "afternoon",
  NIGHT = "night",
}
